'use client';

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  VisuallyHidden,
} from '@baseball-near-you/ui';
import { useUserProfile } from '@bb/lib/hooks/useUserProfile';
import { type ReactNode, useState } from 'react';
import { LoginForm } from '../LoginForm';
import { SignupForm } from '../SignupForm';
import type { ModalTrigger } from '../types';

enum Type {
  Login = 'login',
  SignUp = 'signup',
}
export function LoginModal(props: { modalTrigger?: ModalTrigger }) {
  const [type, setType] = useState(Type.Login);
  const [open, setOpen] = useState(false);

  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        setOpen(open);
      }}
    >
      <DialogTrigger asChild>
        {props.modalTrigger ? (
          props.modalTrigger({ open, setOpen })
        ) : (
          <Button variant="outline" className="border-red text-red">
            Login
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <VisuallyHidden>
          <DialogTitle aria-describedby="login or signup here">
            Login or signup!
          </DialogTitle>
        </VisuallyHidden>
        {type === Type.Login ? (
          <LoginForm
            onLoginSuccess={() => {
              setOpen(false);
            }}
            onSignupClick={() => {
              setType(Type.SignUp);
            }}
          />
        ) : (
          <SignupForm
            onSignupSuccess={() => {
              setOpen(false);
            }}
            onLoginClick={() => {
              setType(Type.Login);
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

export function ProtectedAuthModal(props: {
  modal: ReactNode;
  modalTrigger?: ModalTrigger;
}) {
  // if the user is not logged in, show the login modal
  // otherwise show the protected modal
  const { userProfile } = useUserProfile();
  if (!userProfile) {
    return <LoginModal modalTrigger={props.modalTrigger} />;
  }

  return props.modal;
}
